import React, { useState } from 'react';
import { map, size, get, sortBy, some, toNumber, toString, findIndex } from 'lodash';
import { sortableContainer } from 'react-sortable-hoc';
import { bool, func, object, number } from 'prop-types';
import { Button, Row, FormInput, Text, Column, Icon } from '../../../../common';
import MultipleOption, { CustomCheckbox, CustomRadioButton } from './MultipleOption';
import { arrayMove, genUUID, typeQuestions } from '../../../../../utils/misc';

const SortableContainer = sortableContainer(({ children }) => {
    return <div>{children}</div>;
});

const MultipleOptions = ({ isActiveQuestion, question, updateQuestions, activeOptionId, setActiveOptionId, typeQuestion, limitSelect }) => {
    const [sortStart, setSortStart] = useState(false);
    const [optionMoved, setOptionMoved] = useState(null);
    const [indexLastOptionDragged, setIndexLastOptionDragged] = useState(null);
    const [showOtherBtn, setShowOtherBtn] = useState(true);
    const options = get(question, 'options', []);
    const hasOtherOption = some(options, { type: 2 });
    const [isHoverButton, setIsHoverButton] = useState(false);

    const orderOtherOption = (options) => {
        var indexOtherOption = findIndex(options, { type: 2 });

        if (indexOtherOption > -1) {
            const removedOption = options.splice(indexOtherOption, 1)[0];
            options.push(removedOption);
        }

        return map(options, (option, index) => ({ ...option, orden: index + 1 }) )
    }

    const onSortEnd = ({ oldIndex, newIndex }) => {
        oldIndex === newIndex ? setOptionMoved(false) : setOptionMoved(true);
        setIndexLastOptionDragged(oldIndex);
        setSortStart(false);
        const newOptions = arrayMove(get(question, 'options'), oldIndex, newIndex);
        updateQuestions('options', orderOtherOption(newOptions));
    };

    const onSortStart = () => {
        setIndexLastOptionDragged(null);
        setOptionMoved(null);
        setSortStart(true);
    };

    const addOption = (isOther) => {
        isOther && setShowOtherBtn(false);
        const description = isOther ? 'Otro' : `Opción ${size(options) + 1}`;
        const index = hasOtherOption ? size(options) - 1 : size(options);

        options.splice(index, 0, { description, idOption: genUUID(), type: isOther ? 2 : 1 });

        updateQuestions('options', orderOtherOption(options));
    };

    const showBtn = () => !hasOtherOption && showOtherBtn;

    return <>
        <SortableContainer useDragHandle onSortStart={onSortStart} onSortEnd={onSortEnd}>
            {map(sortBy(get(question, 'options'), 'orden'), (option, index) => {
                return <MultipleOption
                    option={option}
                    key={index}
                    index={index}
                    setActiveOptionId={setActiveOptionId}
                    activeOptionId={activeOptionId}
                    isActiveQuestion={isActiveQuestion}
                    sortStart={sortStart}
                    indexLastOptionDragged={indexLastOptionDragged}
                    optionMoved={optionMoved}
                    question={question}
                    updateQuestions={updateQuestions}
                    typeQuestion={typeQuestion}
                    setShowOtherBtn={setShowOtherBtn}
                />;
            })}
        </SortableContainer>
        {isActiveQuestion && <Column>
            <Row
                justify='flex-start'
                align='center'
                gap={10}
                minHeight='35px'
            >
                <div style={{ width: 20 }} />
                {typeQuestion === typeQuestions.MULTIPLE ? <CustomCheckbox /> : <CustomRadioButton />}
                <Button text='Agregar opción' link onClick={() => addOption(false)} backgroundColor='#F4F4F4' fitContent padding='0px 0px' textTransform='none' />
            </Row>
            <Row onClick={() => setActiveOptionId(null)} mT={10}>
                {showBtn() && <Button
                    left={56}
                    width={300}
                    onClick={() => addOption(true)}
                    secondaryQuestion
                    onMouseEnter={() => setIsHoverButton(true)}
                    onMouseLeave={() => setIsHoverButton(false)}
                >
                    <Row justify='flex-end' align='center' gap={7}>
                        <Icon name='new-plus' color={!isHoverButton ? '#a4c735' : '#ffffff'} size={18} />
                        Agregar respuesta "Otro"
                    </Row>
                </Button>}
                <Row onClick={() => setActiveOptionId(null)} align='center' justify='flex-end' gap={10}>
                    {typeQuestions.MULTIPLE === typeQuestion && <>
                        <Text text='Límite de selección:' />
                        <FormInput
                            onChange={({ target }) => {
                                const value = toNumber(get(target, 'value'));
                                value <= size(options) && updateQuestions('limitSelect', value);
                            }}
                            width='40px'
                            type='number'
                            value={toString(limitSelect)}
                            style={{ margin: 0 }}
                        />
                    </>}
                </Row>
            </Row>
        </Column>}
    </>;
};

MultipleOptions.propTypes = {
    isActiveQuestion: bool,
    question: object,
    updateQuestions: func,
    activeOptionId: number,
    setActiveOptionId: func,
    typeQuestion: number,
    limitSelect: number
};

export default MultipleOptions;
